import { IconSearch16, Input } from '@cian/ui-kit';
import styles from './SearchField.css';
import { jsx as _jsx } from "react/jsx-runtime";
export var SearchField = function SearchField(props) {
  var value = props.value,
      onChange = props.onChange;
  return /*#__PURE__*/_jsx(Input, {
    "data-testid": "search-input",
    leftAdornment: /*#__PURE__*/_jsx("div", {
      className: styles['search-icon-wrapper'],
      children: /*#__PURE__*/_jsx(IconSearch16, {})
    }),
    placeholder: "\u041F\u043E\u0438\u0441\u043A",
    value: value,
    onChange: onChange
  });
};